import React, {Component} from "react";

class AmountNotationFilter extends Component {
    state = {
        amount_type: 'Thousand',
    };
    componentDidMount(){

    }
    resetAmountNotationFilter(){
        this.setState({
            amount_type: 'Thousand',
        })
    }
    changeAmtType(amt, e) {
        this.setState({
            amount_type:amt,
            isChange: true
        });
        this.props.onSelectAmountNotation(amt);
    }
    render() {

        var vcls1 = "btn btn-sm btn-default switchMetric";
        var ccls1 = "btn btn-sm btn-default switchMetric";
        if(this.state.amount_type=='Thousand' ) {
            vcls1 = "btn btn-sm btn-primary switchMetric";
            ccls1 = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.amount_type=='Lakhs' ) {
            vcls1 = "btn btn-sm btn-default switchMetric";
            ccls1 = "btn btn-sm btn-primary switchMetric";
        }
        return (
            <div className="alignedCenter">
                <div className="btn-group">
                    <button className={vcls1} type="button" value="Thousand" onClick={this.changeAmtType.bind(this,'Thousand')}>Thousand </button>
                    <button className={ccls1} type="button" value="Lakhs" onClick={this.changeAmtType.bind(this,'Lakhs')}>Lakhs </button>
                </div>
            </div>
        );
    }
}
export default AmountNotationFilter;